import React, { useRef, useState, useCallback } from 'react';
import './ProgressBar.less';

const ProgressBar = ({ currentTime = 0, duration = 0, onSeek }) => {
  const barRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const progressPercent = !duration || duration <= 0
    ? 0
    : Math.min(100, Math.max(0, (currentTime / duration) * 100));

  const formatTime = (seconds) => {
    if (!seconds || seconds < 0) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const getTimeFromEvent = (e) => {
    if (!barRef.current || !duration) return 0;
    const rect = barRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
    return (x / rect.width) * duration;
  };

  const handleClick = useCallback(
    (e) => {
      const time = getTimeFromEvent(e);
      onSeek?.(time);
    },
    [duration, onSeek],
  );

  const handleMouseDown = useCallback(
    (e) => {
      setIsDragging(true);

      const handleMouseMove = (moveEvent) => {
        const time = getTimeFromEvent(moveEvent);
        onSeek?.(time);
      };

      const handleMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };

      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    },
    [duration, onSeek],
  );

  return (
    <div className="progress-bar" ref={barRef} onClick={handleClick} onMouseDown={handleMouseDown}>
      <div className="progress-track">
        <div className="progress-fill" style={{ width: `${progressPercent}%` }} />
      </div>
      <div className="progress-thumb" style={{ left: `${progressPercent}%` }} />
      <div className="progress-time">
        <span>{formatTime(currentTime)}</span>
        <span>{formatTime(duration)}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
